<template>

    <tbody style="position: relative;">
        <tr class="new-row-animation event-overview-row">
            <td class="tx-mobile-flex-content">

                <!--<ui-link class="tx-table-cell-icon tx-table__badge&#45;&#45;burn" v-bind:to="transactionRoute" v-if="!type">-->
                <!--    <icon-tx-burn />-->
                <!--</ui-link>-->
                <ui-link class="tx-table-cell-icon tx-table__badge--sale" v-bind:to="transactionRoute" v-if="type === 'nft_put_on_sale' || type ==='nft_update_sale'">
                    <icon-tx-sale />
                </ui-link>
                <ui-link class="tx-table-cell-icon tx-table-cell-icon--out" v-bind:to="transactionRoute" v-if="type === 'nft_transfer'">
                    <icon-tx-sent />
                </ui-link>
                <ui-link class="tx-table-cell-icon tx-table__badge--bid" v-bind:to="transactionRoute" v-if="type === 'teleitem_start_auction' || type === 'nft_put_on_auction' || type === 'dns_release' || type === 'auction_bid'">
                    <icon-tx-bid />
                </ui-link>
                <ui-link class="tx-table-cell-icon tx-table-cell-icon--in" v-bind:to="transactionRoute" v-if="type === 'nft_mint' || type === 'deploy_nft'">
                    <icon-tx-mint />
                </ui-link>
                <ui-link class="tx-table-cell-icon tx-table-cell-icon--out" v-bind:to="transactionRoute" v-if="type === 'nft_cancel_sale'">
                    <icon-tx-cancel />
                </ui-link>
                <ui-link class="tx-table-cell-icon tx-table-cell-icon--out" v-bind:to="transactionRoute" v-if="type === 'teleitem_cancel_auction' || type === 'nft_cancel_auction' || type === 'nft_finish_auction'">
                    <icon-tx-cancel-bid />
                </ui-link>
                <ui-link class="tx-table-cell-icon tx-table__badge--sold" v-bind:to="transactionRoute" v-if="type === 'nft_purchase' || type === 'dns_purchase'">
                    <icon-tx-sold />
                </ui-link>

                <div class="tx-mobile-content">
                    <div class="tx-block-mobile-content__wrapper tx-block-mobile-content-swap-wrapper">
                        <div class="tx-block-mobile-content__row tx-block-mobile-swap-items">
                            <div class="tx-block-mobile-content__left">
                                <ui-timeago class="muted" v-bind:timestamp="time"/>
                            </div>
                            <div class="tx-block-mobile-content__right">
                                <template v-if="price && type !== 'cancel-sale'">
                                    <span>{{ $ton(price) }} TON</span>
                                </template>
                            </div>
                        </div>
                        <div class="tx-block-mobile-content__row">
                            <div class="tx-block-mobile-content__left" style="padding-right: 0">
                                <template v-if="from">
                                    <nft-history-address v-bind:address="from" />
                                </template>

                                <div class="tx-table-action-icon" v-if="from && to">
                                    <arrow-right />
                                </div>

                                <template v-if="to">
                                    <nft-history-address v-bind:address="to" />
                                </template>

                                <span v-if="!from && !to" class="muted">{{ $t('common.empty') }}</span>
                            </div>
                            <div class="tx-block-mobile-content__right">
                                <span class="muted" v-if="!type">{{ $t('nft.item.mobile_badge.burn') }}</span>
                                <span class="muted" v-if="type === 'mint'">{{ $t('nft.item.mobile_badge.mint') }}</span>
                                <span class="muted" v-if="type === 'cancel-sale'">{{ $t('nft.item.mobile_badge.cancel_sale') }}</span>
                                <span class="muted" v-if="type === 'cancel-auction'">{{ $t('nft.item.mobile_badge.cancel_bid') }}</span>
                                <span class="muted" v-if="type === 'put-up-for-auction'">{{ $t('nft.item.mobile_badge.bid') }}</span>
                                <span class="muted" v-if="type === 'put-up-for-sale'">{{ $t('nft.item.mobile_badge.sale') }}</span>
                                <span class="muted" v-if="type === 'transfer'">{{ $t('nft.item.mobile_badge.sent') }}</span>
                                <!-- {{ type }} -->
                            </div>
                        </div>

                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</template>

<script>
// import IconTxBurn from '@img/icons/tonscan/badges/burn.svg?vue';
import IconTxSale from '@img/icons/tonscan/badges/sale.svg?vue';
import IconTxSent from '@img/icons/tonscan/badges/sent.svg?vue';
import IconTxBid from '@img/icons/tonscan/badges/bid.svg?vue';
import IconTxMint from '@img/icons/tonscan/badges/mint.svg?vue';
import IconTxCancel from '@img/icons/tonscan/badges/cancel.svg?vue';
import IconTxCancelBid from '@img/icons/tonscan/badges/cancel-bid.svg?vue';
import IconTxSold from '@img/icons/tonscan/badges/sold.svg?vue';
import ArrowRight from '@img/icons/tonscan/arrow-small-right.svg?vue';
import NftHistoryAddress from '~/components/nft/NftHistoryAddress.vue';

export default {
    props: {
        hash: String,
        time: Number,
        from: String,
        to: String,
        price: String,
        type: String,
        marketplace: String,
    },

    computed: {
        transactionRoute() {
            return {
                name: 'tx',
                params: {
                    hash: this.hash,
                },
            };
        },
    },

    components: {
        NftHistoryAddress,
        // IconTxBurn,
        IconTxSale,
        IconTxSent,
        IconTxBid,
        IconTxMint,
        IconTxCancel,
        IconTxCancelBid,
        IconTxSold,
        ArrowRight,
    },
};
</script>

<style lang="scss">
.tx-mobile-block-row {
    margin-bottom: 4px;
}

.tx-mobile-block-row:last-child {
    margin-bottom: 0;
}

.tx-mobile-top-margin {
    margin-top: 11px;
}
</style>
